module.exports = __webpack_public_path__ + "img/Icon_Chevron_Down_white.f933f504.svg";